import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { z } from 'zod';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { AppError } from '@/lib/api/errors';
import { useSubscribe } from './api';

const schema = z.object({ email: z.string().email('Enter a valid email') });
type FormValues = z.infer<typeof schema>;

export function NewsletterSignup() {
  const subscribe = useSubscribe();
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm<FormValues>({ resolver: zodResolver(schema) });

  const onSubmit = handleSubmit(async (values) => {
    await subscribe.mutateAsync(values.email);
  });

  if (subscribe.isSuccess) {
    return (
      <p className="text-sm text-teal-700">
        Thanks! Please check your inbox to confirm your subscription.
      </p>
    );
  }

  return (
    <form onSubmit={onSubmit} className="space-y-2" noValidate>
      <div className="flex gap-2">
        <Input
          type="email"
          placeholder="you@example.com"
          aria-label="Email address"
          {...register('email')}
          aria-invalid={!!errors.email}
        />
        <Button type="submit" loading={isSubmitting} variant="secondary">
          Subscribe
        </Button>
      </div>
      {errors.email && <p className="text-xs text-red-600">{errors.email.message}</p>}
      {subscribe.isError && (
        <p className="text-xs text-red-600">
          {subscribe.error instanceof AppError ? subscribe.error.message : 'Please try again.'}
        </p>
      )}
    </form>
  );
}
